export function getLocaleFromTimezone() {
  return 'en';
  // getTimezoneOffset returns the difference, in minutes, between UTC and local time. UTC+7 is -420.
  const offset = new Date().getTimezoneOffset();
  if (offset === -420) {
    return 'vn';
  }
  return 'en';
}
